var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimer = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.368 1.473H5.42a.737.737 0 1 1 0-1.473h2.948-.001a.737.737 0 0 1 0 1.473ZM6.894 2.21a5.895 5.895 0 1 0 0 11.79 5.895 5.895 0 0 0 0-11.79Zm.737 5.895a.737.737 0 0 1-1.474 0v-2.21a.737.737 0 0 1 1.474 0v2.21Z"
})));
SvgTimer.viewBox = '0 0 14 14';
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimer);
export default ForwardRef;